module.exports = import("https://embed.jolly.tools/iframe/index.mjs");;